export const DEFAULT_GOOGLEMAPS_API_KEY =
  'AIzaSyAcHzggNOisPIShAEuOa2KZ5BR23L8sepY';
export const FRESHWORKS_WIDGET_ID = '73000003079';
export const HOTJAR_APP_ID = '2816288';
export const BEAMER_PRODUCT_ID = 'RYFHOYMm44367';
export const AUDIENCE_JWT = 'https://cerebro.techrayo.com/jwt';
